
import { IResourceComponentsProps, useExport, useMany, useNavigation, useOne } from '@pankod/refine-core'
import ReactMarkdown from 'react-markdown'
import { Form, Select, Drawer } from 'antd';
import { nhost } from 'utility';
import {
    List,
    RefreshButton,
    CreateButton,
    ExportButton,
    Table,
    useTable,
    Space,
    EditButton,
    DeleteButton,
    DateField,
    getDefaultSortOrder,
    useModalForm,
    Icons,
    Typography,
    Popover,
    Button,
    Divider,
    Row,
    Col,
} from '@pankod/refine-antd'

import { IGrade, IQuestionHistory } from 'interfaces'
import { useEffect, useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { GET_HISTORY_LOG,  } from 'gql/queries';


const { PlusOutlined } = Icons
interface DescriptionItemProps {
    title: string;
    content: React.ReactNode;
  }
const DescriptionItem = ({ title, content }: DescriptionItemProps) => (
   
    <div className="site-description-item-profile-wrapper" style={{display:'flex',alignItems:'baseline'}}>
        
      <p className="site-description-item-profile-p-label"> {title} : </p>
   {content}
    </div>
  );
export const QuestionLogs: React.FC<IResourceComponentsProps> = () => {
    const [open, setOpen] = useState(false);
    const [data, setData] = useState<any>({});
    const [isIdLoaded, setIsIdLoaded] = useState(false);
    const [gradeIds,setGradeIds]=useState([])

    const showDrawer = (record:any,show:boolean) => {
      if(record?.modified_values?.grade_ids!==undefined && record?.modified_values?.grade_ids!==null){
      setGradeIds(record?.modified_values?.grade_ids)

setIsIdLoaded(true)
      }
      setData(record)
        setOpen(show);
      };
    
      const onClose = () => {
        setData([])
        setOpen(false);
      };
      const { data:grades, isLoading, isError } = useMany<IGrade>({
        resource: "grades",
        metaData: {
          fields:['name']
        },
        queryOptions:{enabled:isIdLoaded},
        ids:gradeIds
        
    });
console.log({grades})
    const { tableProps, sorter, tableQueryResult } = useTable<IQuestionHistory>({
        resource: "audit_dependency_question_view",
        initialSorter: [
            {
                field: 'created_at',
                order: 'desc',
            },
        ],
        metaData: {
            fields: [  'id',
                'session_user_name',
                'hasura_user',
                'record_id',
                'created_at',
                'action',
                'old_value',
                'new_value',
                'modified_values',
                { creator_details: ['displayName'] },
                { question_details: ['title','question_id'] },
                { report_theme_details: ['name'] },
                { sub_theme_details: ['name'] },
                { subject_details: ['name'] },
                { theme_details: ['name'] },
                { topic_details: ['name'] },
                { modified_approver_details: ['displayName'] },
                { modified_creator_details: ['displayName'] },
                { modified_reviewer_details: ['displayName'] },
                { modified_report_theme_details: ['name'] },
                { modified_sub_theme_details: ['name'] },
                { modified_subject_details: ['name'] },
                { modified_theme_details: ['name'] },
                { modified_topic_details: ['name'] },
                { approver_details: ['displayName'] },
                { reviewer_details: ['displayName'] },
                { second_approver_details: ['displayName'] },
                { second_reviewer_details: ['displayName'] },
                { modified_second_reviewer_details: ['displayName'] },
                { modified_second_approver_details: ['displayName'] },
                { bloom_level_details: ['name'] },
                { centa_concept_details: ['name'] },
                { centa_standard_details: ['name'] },
                { competency_aspect_details: ['name'] },
                { competency_details: ['name'] },
                { difficulty_level_details: ['name'] },
                { explanation_type_details: ['name'] },
                { paper_details: ['paper_id'] },
                { question_type_details: ['name'] },
                { strand_details: ['name'] },
                { taxonomy_details: ['name'] },
                { teacher_level_details: ['name'] },
                { modified_question_type_details: ['name'] },
                { modified_centa_standard_details: ['name'] },
                { modified_strand_details: ['name'] },
                { modified_competency_aspect_details: ['name'] },
                { modified_centa_concept_details: ['name'] },
                { modified_taxonomy_details: ['name'] },
                { modified_explanation_type_details: ['name'] },
                { modified_competency_details: ['name'] },
                { modified_teacher_level_details: ['name'] },
                { modified_bloom_level_details: ['name'] },
                { modified_difficulty_level_details: ['name'] },
                { modified_paper_details: ['paper_id'] },
                { work_request_details: ['name'] },
                { modified_work_request_details: ['name'] },
                { created_user_details: ['displayName'] },
                { modified_created_user_details: ['displayName'] },
                { updated_user_details: ['displayName'] },
                { modified_updated_user_details: ['displayName'] },
                { hasura_user_details: ['displayName'] },
                


              
                

         
            ],
        },
    })
 const renderGrades=()=>{
  let result:string=''
  if(grades!==undefined && grades?.data?.length>0){
    // alert(1)
    const names: string[] = grades?.data?.map((item:IGrade )=> String(item.name));
     result = names.join(', ');
    console.log({result});



  }
  return   <DescriptionItem title={'GRADES'} content={result} />
 }
    const renderData = () => {
        if (data && data.modified_values) {
          return Object.entries(data.modified_values).map(([key, value]) => (
            <Col span={12} key={key}>
                {
                key.includes("subject_id")?
                <DescriptionItem title={key.toUpperCase().replace('_', ' ')} content={data?.modified_subject_details?.name} />
                :
                key.includes("report_theme_id")?
                <DescriptionItem title={key.toUpperCase().replace('_', ' ')} content={data?.modified_report_theme_details?.name} />
                :
                key.includes("theme_id")?
                <DescriptionItem title={key.toUpperCase().replace('_', ' ')} content={data?.modified_theme_details?.name} />
                :
                key.includes("sub_theme_id")?
                <DescriptionItem title={key.toUpperCase().replace('_', ' ')} content={data?.modified_sub_theme_details?.name} />
                :
                key.includes("topic_id")?
                <DescriptionItem title={key.toUpperCase().replace('_', ' ')} content={data?.modified_topic_details?.name} />
                :
                key.includes("creator_id")?
                <DescriptionItem title={key.toUpperCase().replace('_', ' ')} content={data?.modified_creator_details?.displayName} />
                :
                key.includes("reviewer_id")?
                <DescriptionItem title={key.toUpperCase().replace('_', ' ')} content={data?.modified_reviewer_details?.displayName} />
                :
                key.includes("approver_id")?
                <DescriptionItem title={key.toUpperCase().replace('_', ' ')} content={data?.modified_approver_details?.displayName} />
                :
                key.includes("question_type_id")?
                <DescriptionItem title={key.toUpperCase().replace('_', ' ')} content={data?.modified_question_type_details?.name} />
                :
                key.includes("centa_standard_id")?
                <DescriptionItem title={key.toUpperCase().replace('_', ' ')} content={data?.modified_centa_standard_details?.name} />
                :
                key.includes("strand_id")?
                <DescriptionItem title={key.toUpperCase().replace('_', ' ')} content={data?.modified_strand_details?.name} />
                :
                key.includes("competency_aspect_id")?
                <DescriptionItem title={key.toUpperCase().replace('_', ' ')} content={data?.modified_competency_aspect_details?.name} />
                :
                key.includes("centa_concept_id")?
                <DescriptionItem title={key.toUpperCase().replace('_', ' ')} content={data?.modified_centa_concept_details?.name} />
                :
                key.includes("tn_taxonomy_id")?
                <DescriptionItem title={key.toUpperCase().replace('_', ' ')} content={data?.modified_centa_concept_details?.name} />
                :
                key.includes("explanation_type_id")?
                <DescriptionItem title={key.toUpperCase().replace('_', ' ')} content={data?.modified_explanation_type_details?.name} />
                :
                key.includes("competency_id")?
                <DescriptionItem title={key.toUpperCase().replace('_', ' ')} content={data?.modified_competency_details?.name} />
                :
                key.includes("teacher_level_id")?
                <DescriptionItem title={key.toUpperCase().replace('_', ' ')} content={data?.modified_teacher_level_details?.name} />
                :
                key.includes("paper_id")?
                <DescriptionItem title={key.toUpperCase().replace('_', ' ')} content={data?.modified_paper_details?.paper_id} />
                :
                key.includes("bloom_level_id")?
                <DescriptionItem title={key.toUpperCase().replace('_', ' ')} content={data?.modified_bloom_level_details?.name} />
                :
                key.includes("difficulty_level_id")?
                <DescriptionItem title={key.toUpperCase().replace('_', ' ')} content={data?.modified_difficulty_level_details?.name} />
                :
                key.includes("second_reviewer_id")?
                <DescriptionItem title={key.toUpperCase().replace('_', ' ')} content={data?.modified_second_reviewer_details?.displayName} />
                :
                key.includes("second_approver_id")?
                <DescriptionItem title={key.toUpperCase().replace('_', ' ')} content={data?.modified_second_approver_details?.displayName} />
                :
                key.includes("work_request_id")?
                <DescriptionItem title={key.toUpperCase().replace('_', ' ')} content={data?.modified_work_request_details?.name} />
                :
                key.includes("created_by")?
                <DescriptionItem title={key.toUpperCase().replace('_', ' ')} content={data?.modified_created_user_details?.displayName} />
                :
                key.includes("updated_by")?
                <DescriptionItem title={key.toUpperCase().replace('_', ' ')} content={data?.modified_updated_user_details?.displayName} />
                :
                key.includes("grade_ids")?
               renderGrades()
                :
                !key.includes("option_details") &&  !key.includes("grade_ids")?
              <DescriptionItem title={key.toUpperCase().replace('_', ' ')} content={value===false?'false':value===true?'true': value} />
              :null
                }
            </Col>
          ));
        } else {
          return null; // Or you can return a placeholder component or message
        }
      };
      const renderDataOld = () => {
        if (data && data.modified_values) {
          return Object.entries(data.modified_values).map(([key, value]) => (
            Object.entries(data.old_value).map(([oldKey, oldValue]) => (
                key===oldKey?
            <Col span={12} key={key}>
               
              <DescriptionItem title={oldKey.toUpperCase().replace('_', ' ')} content={oldValue===false?'false':oldValue===true?'true': oldValue} />
            </Col>
            :null
            ))
          ));
        } else {
          return null; // Or you can return a placeholder component or message
        }
      };
      
        // <li key={key}>
        //   Key: {key}, Value: {value}
        // </li>
    
  



    return (
        <List
            pageHeaderProps={{
                extra: [
                    //  <ExportButton onClick={triggerExport} loading={isLoading} />,
                    <RefreshButton onClick={() => tableQueryResult?.refetch()} />,

                ],
            }}
        >
          
         
            <Divider />
            <Table {...tableProps} rowKey="id" size="small">
                
                <Table.Column dataIndex="action" title="Task Type" />
                <Table.Column<IQuestionHistory> dataIndex="question_title" title="Title"
                    render={(_, record) => (
                        <Typography.Text >
                            {record?.question_details?.title}
                        </Typography.Text>
                    )} />
                      <Table.Column<IQuestionHistory> dataIndex="hasura_user" title="User"
                    render={(_, record) => (
                        <Typography.Text >
                            {record?.hasura_user_details?.displayName}
                        </Typography.Text>
                    )} />
                {/* <Table.Column dataIndex="user_role" title="Role" /> */}

                <Table.Column
                    dataIndex="created_at"
                    title="Created At"
                    render={value => <DateField value={value} format="LLL" />}
                    defaultSortOrder={getDefaultSortOrder('created_at', sorter)}
                    sorter
                />
                <Table.Column<IQuestionHistory>
                    title="Actions"
                    dataIndex="actions"
                    render={(_, record) => (
                        <Space>
                             {/* <a onClick={showDrawer} key={`a-${item.id}`}>
                View Profile
              </a>, */}
                           <Button  onClick={()=>showDrawer(record,true)}>View Changes</Button>
                           
                        </Space>
                    )}
                />
            </Table>
            <Drawer width={1000} placement="right"    closable={false} onClose={onClose} visible={open}>
        <p className="site-description-item-profile-p" style={{ marginBottom: 24 }}>
       QUESTION HISTORY LOG
        </p>
        {console.log({data})}
        {/* <p className="site-description-item-profile-p">Personal</p> */}
        <Row>
          <Col span={12}>
            <DescriptionItem title="Title" content={data?.question_details?.title}/>
          </Col>
          <Col span={12}>
            <DescriptionItem title="ID" content={data?.question_details?.question_id} />
          </Col>
        </Row>
        
       
      {data?.action!=="INSERT"?
      <>
        <Divider />
        <p className="site-description-item-profile-p">Old Values</p>
        <Row>
          <Col span={12}>
            <DescriptionItem title="Subject" content={data?.subject_details?.name}/>
          </Col>
          <Col span={12}>
            <DescriptionItem title="Report theme" content={data?.report_theme_details?.name} />
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <DescriptionItem title="Theme" content={data?.theme_details?.name}/>
          </Col>
          <Col span={12}>
            <DescriptionItem title="Sub theme" content={data?.sub_theme_details?.name} />
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <DescriptionItem title="Topic" content={data?.topic_details?.name}/>
          </Col>
          {/* <Col span={12}>
            <DescriptionItem title="Sub theme" content={data?.sub_theme_details?.name} />
          </Col> */}
        </Row>
        <Row>
            {renderDataOld()}
        </Row>
        </>
        :null}
       
        <Divider />
        <p className="site-description-item-profile-p">Modified Values</p>
        <Row>
            {renderData()}
          {/* <Col span={12}>
            <DescriptionItem title="Email" content="AntDesign@example.com" />
          </Col>
          <Col span={12}>
            <DescriptionItem title="Phone Number" content="+86 181 0000 0000" />
          </Col>
       
          <Col span={24}>
            <DescriptionItem
              title="Github"
              content={
                <a href="http://github.com/ant-design/ant-design/">
                  github.com/ant-design/ant-design/
                </a>
              }
            />
          </Col> */}
        </Row>
      </Drawer>

        </List>
    )
}
